import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledQuestionHeading = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
`;

export const StyledRadioInputWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.6rem;
`;

export const StyledTypeSelectInputWrapper = styled.div`
  margin-top: 1.6rem;
  width: 80%;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 100%;
  }
`;

export const StyledTaskButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1.6rem;
  margin-top: 3.2rem;
`;

export const StyledQuestionOptionButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.background.secondary};
  &&:hover {
    svg {
      color: ${({ theme }) => theme.colors.black};
    }
  }
`;

export const StyledAddQuestionButton = styled(StyledQuestionOptionButton)`
  margin-top: 1.6rem;
`;

export const StyledDateTimePicker = styled.div`
  position: relative;
  & > div > .react-datepicker__tab-loop > .react-datepicker-popper {
    z-index: 4;
  }

  & > div[role='tooltip'] {
    position: absolute;
    z-index: 1;
    top: -5rem;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
  }
  &:hover {
    & > div[role='tooltip'] {
      visibility: visible;
      opacity: 1;
    }
  }
`;

export const StyledTooltipText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 1.5rem;
`;

export const StyledDateSection = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
`;
